import { Icon } from "@/components/icons/Icon";
import { getFileIconName } from "@/models/utils/getFileIconName";
import { twMerge } from "@/utils/twMerge";

import type { ReactNode } from "react";

type FileCardProps = {
  filename: string;
  contentType: string;
  selected?: boolean;
  actions?: ReactNode;
  children?: ReactNode;
};

export function FileCard({ filename, contentType, selected, actions, children }: FileCardProps) {
  return (
    <div
      className={twMerge(
        "@container flex items-center justify-center gap-1 w-full min-w-0 h-11 px-2 rounded-12 cursor-default select-none",
        "border border-gray-200 dark:border-gray-700 bg-document-bg",
        selected && "border-icon-active dark:border-icon-active",
      )}
    >
      <Icon
        name={getFileIconName({ type: contentType, name: filename })}
        width={28}
        height={28}
        className="shrink-0 hidden @min-[72px]:block"
      />
      <div className="hidden @min-[72px]:flex gap-1 w-full min-w-0 overflow-hidden tracking-tight text-[15px]">
        <span className="min-w-0 truncate text-document-text font-medium">{filename}</span>
        {children}
      </div>
      {actions}
    </div>
  );
}
